import styled from 'styled-components';
import { whiteTheme } from 'modules/hairmakeup/styles/themes/whiteTheme';
import { SideTextMain } from 'modules/main/components/SideTextMain';

export const NewsWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-left: -20px;
  margin-right: -20px;
  ${whiteTheme.media.laptop} {
    margin: 0;
  }
`;

export const Main = styled(SideTextMain)`
  flex-wrap: wrap;
  ${whiteTheme.media.mobileM} {
    padding-top: 70px;
  }
`;

export const MainContent = styled.section`
  display: flex;
  align-items: center;
  flex-direction: column;
  flex: 1;
  max-width: 1240px;
  width: 100%;
  position: relative;
`;

export const Wrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 20px;
  padding-right: 20px;
  ${whiteTheme.media.tablet} {
    flex-direction: column;
  }
  ${whiteTheme.media.mobileM} {
    padding: 0 17.5px;
  }
`;

export const WrapSP = styled.div`
  max-width: 700px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  ${whiteTheme.media.desktop} {
    max-width: 490px;
  }
`;

export const MainH1Title = styled.h1`
  width: 100%;
  text-align: center;
  font-family: cormorant-garamond, serif;
  font-weight: 500;
  font-style: normal;
  font-size: 34px;
  color: #000000;
  line-height: 22px;
  display: block;
  margin-bottom: 50px;
  text-decoration: none;
  transition: 0.3s;
  word-break: break-all;
  ${whiteTheme.media.tablet} {
    font-size: 28px;
  }
  ${whiteTheme.media.mobileM} {
    margin: 15px 0;
  }
`;
